import { render, staticRenderFns } from "./d-book-chapter.vue?vue&type=template&id=1803d05b&scoped=true&"
import script from "./d-book-chapter.vue?vue&type=script&lang=js&"
export * from "./d-book-chapter.vue?vue&type=script&lang=js&"
import style0 from "./d-book-chapter.vue?vue&type=style&index=0&id=1803d05b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1803d05b",
  null
  
)

export default component.exports